import script from "./RegisterIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./RegisterIcon.vue?vue&type=script&setup=true&lang=js"

import "./RegisterIcon.vue?vue&type=style&index=0&id=6f4150a9&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f4150a9"]])

export default __exports__